import React from 'react';
import { Tag } from 'antd';

const ActiveStatus = ({ isActive, displayActive = false }) => {
  return isActive === false ? (
    <Tag color="gold" className="m-0">
      INACTIVE
    </Tag>
  ) : displayActive ? (
    <Tag color="green" className="m-0">
      ACTIVE
    </Tag>
  ) : null;
};

export default ActiveStatus;
